export default "__VITE_ASSET__B0h3hBTl__"